import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import {convertPipeToBrTag} from "../../utils";
import {WINDOW, NAVIGATOR} from '../../constants/environment'
import './styles.css';

/**
 *  Sitemap
 */
class Sitemap extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape({
      pageName: PropTypes.string,
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      href: PropTypes.string,
      external: PropTypes.bool,
      current: PropTypes.bool,
    }))
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    links: null
  };
  
  constructor(props) {
    super();
    this.props = props;
  }

  componentDidMount() {

  }
  
  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      links
    } = this.props;
        
    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <div className='Sitemap'>
          <div className='Sitemap__container'>
            {(() => {
              if(links && Array.isArray(links) && links.length > 0){
                return (
                  <ul className='Sitemap__container__list-lv2'>
                  {links.map((link_lv2, index_lv2) => {
                    let href = link_lv2.href && link_lv2.href !== '' ? link_lv2.href : null;
                    let target = link_lv2.external != null && link_lv2.external === true ? '_blank' : null;
                    let pcText = link_lv2.pcText && link_lv2.pcText !== '' ? link_lv2.pcText : (link_lv2.pageName && link_lv2.pageName !== '' ? link_lv2.pageName : null);
                    let mbText = link_lv2.mbText && link_lv2.mbText !== '' ? link_lv2.mbText : (link_lv2.pcText && link_lv2.pcText !== '' ? link_lv2.pcText : (link_lv2.pageName && link_lv2.pageName !== '' ? link_lv2.pageName : null));
                    return (
                      <li className='Sitemap__container__list-lv2__item' key={index_lv2}>
                        <a href={href} target={target} className='Sitemap__container__list-lv2__item__link'>
                          {pcText ? <span className='Sitemap__container__list-lv2__item__link__text--pc' dangerouslySetInnerHTML={{__html: convertPipeToBrTag(pcText)}} /> : null}
                          {mbText ? <span className='Sitemap__container__list-lv2__item__link__text--mb' dangerouslySetInnerHTML={{__html: convertPipeToBrTag(mbText)}}/> : null}
                        </a>
                        {(() => {
                          if(link_lv2.links && Array.isArray(link_lv2.links) && link_lv2.links.length > 0){
                            return (
                              <ul className='Sitemap__container__list-lv3'>
                              {link_lv2.links.map((link_lv3, index_lv3) => {
                                let href = link_lv3.href && link_lv3.href !== '' ? link_lv3.href : null;
                                let target = link_lv3.external != null && link_lv3.external === true ? '_blank' : null;
                                let pcText = link_lv3.pcText && link_lv3.pcText !== '' ? link_lv3.pcText : (link_lv3.pageName && link_lv3.pageName !== '' ? link_lv3.pageName : null);
                                let mbText = link_lv3.mbText && link_lv3.mbText !== '' ? link_lv3.mbText : (link_lv3.pcText && link_lv3.pcText !== '' ? link_lv3.pcText : (link_lv3.pageName && link_lv3.pageName !== '' ? link_lv3.pageName : null));
                                return (
                                  <li className='Sitemap__container__list-lv3__item' key={index_lv3}>
                                    <a href={href} target={target} className='Sitemap__container__list-lv3__item__link'>
                                      {pcText ? <span className='Sitemap__container__list-lv3__item__link__text--pc' dangerouslySetInnerHTML={{__html: convertPipeToBrTag(pcText)}} /> : null}
                                      {mbText ? <span className='Sitemap__container__list-lv3__item__link__text--mb' dangerouslySetInnerHTML={{__html: convertPipeToBrTag(mbText)}}/> : null}
                                    </a>
                                    {(() => {
                                      if(link_lv3.links && Array.isArray(link_lv3.links) && link_lv3.links.length > 0){
                                        return (
                                          <ul className='Sitemap__container__list-lv4'>
                                          {link_lv3.links.map((link_lv4, index_lv4) => {
                                            let href = link_lv4.href && link_lv4.href !== '' ? link_lv4.href : null;
                                            let target = link_lv4.external != null && link_lv4.external === true ? '_blank' : null;
                                            let pcText = link_lv4.pcText && link_lv4.pcText !== '' ? link_lv4.pcText : (link_lv4.pageName && link_lv4.pageName !== '' ? link_lv4.pageName : null);
                                            let mbText = link_lv4.mbText && link_lv4.mbText !== '' ? link_lv4.mbText : (link_lv4.pcText && link_lv4.pcText !== '' ? link_lv4.pcText : (link_lv4.pageName && link_lv4.pageName !== '' ? link_lv4.pageName : null));
                                            return (
                                              <li className='Sitemap__container__list-lv4__item' key={index_lv4}>
                                                <a href={href} target={target} className='Sitemap__container__list-lv4__item__link'>
                                                  {pcText ? <span className='Sitemap__container__list-lv4__item__link__text--pc' dangerouslySetInnerHTML={{__html: convertPipeToBrTag(pcText)}} /> : null}
                                                  {mbText ? <span className='Sitemap__container__list-lv4__item__link__text--mb' dangerouslySetInnerHTML={{__html: convertPipeToBrTag(mbText)}}/> : null}
                                                </a>
                                              </li>
                                            )
                                          })}
                                          </ul>
                                        )
                                      }
                                    })()}
                                  </li>
                                )
                              })}
                              </ul>
                            )
                          }
                        })()}
                      </li>
                    )
                  })}
                  </ul>
                )
              }
            })()}
          </div>
        </div>
      </Wrapper>
    )
  }
  
}

export default Sitemap;



// WEBPACK FOOTER //
// ./src/containers/sitemap/index.jsx